import { IOT_SIM_LIST_LOOKUP } from "api/ApiPath";
import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { injectable } from "tsyringe";
import { IVnSkyOscLookupRepository } from "../domain/repositories/IVnSkyOscLookupRepository";
import { VnSkyOscLookupRequestModel } from "./models/VnSkyOscLookupRequestModel";
import { VnSkyOscLookupResponseModel } from "./models/VnSkyOscLookupResponseModel";

@injectable()
export class VnSkyOscLookupImpl implements IVnSkyOscLookupRepository {
  async lookupOsc(
    params: VnSkyOscLookupRequestModel,
  ): Promise<BaseApiResponseModel<VnSkyOscLookupResponseModel>> {
    return await client?.get(IOT_SIM_LIST_LOOKUP.SINGLE_TRACKING, params);
  }
}
